<app-header [headerStep]="headerStep" [local]="true"></app-header>
<div class="container mx-auto mb-6">
  <div class="bg-gray-50 rounded-lg w-full mt-10">
    <div class="text-center text-pink p-2 sign-title">
      <h1 class="text-lg">{{ resource.signature.policy }} {{ productName }}</h1>
      <h3 class="text-lg text-black">n°{{ reference }}</h3>
    </div>
  </div>
  <div *ngIf="!stepB && endorsement">
    <p class="text-center mt-5">{{ resource.question.signature1 }}</p>
    <div class="my-5">
      <div class="backgroundIframe-ES">
        <ngx-spinner
          type="ball-spin-clockwise"
          bdColor="rgba(0,0,0,0.4)"
          color="#472583"
          [fullScreen]="false"></ngx-spinner>
        <div [hidden]="!condP || !signatureVm.isCondPSigned">
          <pdf-viewer
            #pdfViewer
            [src]="signatureVm.condPUrlEmbed"
            (on-progress)="onProgress($event, electronicSignatureEnum.CondP)"
            (error)="onPdfError($event)"
            [original-size]="false"
            [render-text]="false"
            [autoresize]="true"
            [show-all]="true"
            [external-link-target]="'blank'"
            style="min-width: 327px; height: 380px"></pdf-viewer>
          <div *ngIf="!signatureVm.condPUrlEmbed">
            {{ resource.error.errorCP }}
          </div>
        </div>
        <div [hidden]="!sepa || !signatureVm.isSepaSigned">
          <pdf-viewer
            #pdfViewer2
            [src]="signatureVm.sepaUrlEmbed"
            (on-progress)="onProgress($event, electronicSignatureEnum.Sepa)"
            (error)="onPdfError($event)"
            [original-size]="false"
            [render-text]="false"
            [autoresize]="true"
            [show-all]="true"
            [external-link-target]="'blank'"
            style="min-width: 327px; height: 380px"></pdf-viewer>
          <div *ngIf="!signatureVm.sepaUrlEmbed">{{ resource.error.errorSEPA }}</div>
        </div>
      </div>
    </div>
    <div class="flex my-5">
      <div class="backgroundButton-ES flex px-1 py-0.5 rounded-lg">
        <button
          *ngIf="signatureVm.isCondPSigned"
          class="my-auto flex-1 rounded-xl"
          [ngClass]="getClass(condP)"
          (click)="updateClickButton(electronicSignatureEnum.CondP)">
          {{ resource.signature.condP }}
        </button>
        <button
          *ngIf="signatureVm.isSepaSigned"
          class="my-auto flex-1"
          [ngClass]="getClass(sepa)"
          (click)="updateClickButton(electronicSignatureEnum.Sepa)">
          {{ resource.signature.sepa }}
        </button>
      </div>
    </div>
    <div class="my-5 space-y-4">
      <div class="flex">
        <p-checkbox
          *ngIf="endorsement[currentEndorsementIndex]"
          [binary]="true"
          [ngModel]="endorsement[currentEndorsementIndex].isChecked"
          (ngModelChange)="updateChecks($event)"></p-checkbox>
        <p class="text-ES mx-3 py-0.5">
          <ng-container
            *ngIf="
              signatureVm && signatureVm.condPUrlDl && signatureVm.sepaUrlDl;
              else singleDocumentText
            ">
            {{ resource.signature.readOK_1 }}
            <span class="textB-ES">
              <a [href]="signatureVm.condPUrlDl" target="_blank" rel="noopener">
                {{ resource.signature.condP }}
              </a>
            </span>
            {{ resource.signature.readOK_4 }}
            <span class="textB-ES">
              <a [href]="cgFile" target="_blank" rel="noopener">
                {{ resource.signature.condGen }}
              </a>
            </span>
            {{ resource.signature.readOK_5 }}
            <span class="textB-ES">
              <a [href]="dipaFile" target="_blank" rel="noopener">
                {{ resource.signature.infoDoc }}
              </a>
            </span>
            {{ resource.signature.readOK_3 }}
            <span class="textB-ES">
              <a [href]="signatureVm.sepaUrlDl" target="_blank" rel="noopener">
                {{ resource.signature.sepa }}
              </a>
            </span>
          </ng-container>
          <ng-template #singleDocumentText>
            <ng-container *ngIf="signatureVm && signatureVm.condPUrlDl">
              {{ resource.signature.readOK_1 }}
              <span class="textB-ES">
                <a [href]="signatureVm.condPUrlDl" target="_blank" rel="noopener">
                  {{ resource.signature.condP | lowercase }}
                </a>
              </span>
              {{ resource.signature.readOK_4 }}
              <span class="textB-ES">
                <a [href]="cgFile" target="_blank" rel="noopener">
                  {{ resource.signature.condGen }}
                </a>
              </span>
              {{ resource.signature.readOK_5 }}
              <span class="textB-ES">
                <a [href]="dipaFile" target="_blank" rel="noopener">
                  {{ resource.signature.infoDoc }}
                </a>
              </span>
            </ng-container>
            <ng-container *ngIf="signatureVm && signatureVm.sepaUrlDl && !signatureVm.condPUrlDl">
              {{ resource.signature.readOK_1 }}
              <span class="textB-ES">
                <a [href]="cgFile" target="_blank" rel="noopener">
                  {{ resource.signature.condGen }}
                </a>
              </span>
              {{ resource.signature.readOK_5 }}
              <span class="textB-ES">
                <a [href]="dipaFile" target="_blank" rel="noopener">
                  {{ resource.signature.infoDoc }}
                </a>
              </span>
              {{ resource.signature.readOK_3 }}
              <span class="textB-ES">
                <a [href]="signatureVm.sepaUrlDl" target="_blank" rel="noopener">
                  {{ resource.signature.sepa }}
                </a>
              </span>
            </ng-container>
          </ng-template>
        </p>
      </div>
    </div>
    <div class="flex mb-5 mt-6">
      <button
        *ngIf="endorsement[currentEndorsementIndex]"
        pButton
        [disabled]="!endorsement[currentEndorsementIndex].isChecked"
        type="button"
        class="button-NS w-full"
        [label]="buttonText"
        iconPos="right"
        (click)="validateStepOne()"
        [loading]="isLoading">
        <img
          *ngIf="!isLoading"
          style="position: absolute; right: 1.25rem"
          [src]="resource.signature.logoPhone" />
      </button>
    </div>
    <div class="flex mb-5 mt-6" *ngIf="endorsement.length > 1 && currentEndorsementIndex > 0">
      <button
        pButton
        type="button"
        class="w-full text-medium_light underline text-sm"
        [label]="resource.signature.previousContract"
        iconPos="left"
        (click)="previousEndorsement()"></button>
    </div>
  </div>
  <!--SMS CODE-->
  <div *ngIf="stepB && endorsement" [formGroup]="numericCodeForm">
    <app-info-top [infoTop]="infoTop"></app-info-top>
    <app-question [question]="question" [local]="true"></app-question>
    <div class="flex" [ngClass]="displayErrorText ? 'mt-6 mb-1' : 'my-6'">
      <div class="mx-auto space-x-2">
        <input
          id="NOne"
          class="inputCode-ES"
          formControlName="NOne"
          [maxLength]="1"
          pattern="[0-9]*"
          (input)="onKeyUp($event, 'NTwo')" />
        <input
          id="NTwo"
          class="inputCode-ES"
          formControlName="NTwo"
          pattern="[0-9]*"
          [maxLength]="1"
          (input)="onKeyUp($event, 'NThree')" />
        <input
          id="NThree"
          class="inputCode-ES"
          formControlName="NThree"
          pattern="[0-9]*"
          [maxLength]="1"
          pattern="[0-9]*"
          (input)="onKeyUp($event, 'NFour')" />
        <input
          id="NFour"
          class="inputCode-ES"
          formControlName="NFour"
          [maxLength]="1"
          pattern="[0-9]*"
          (input)="onKeyUp($event, 'NFive')" />
        <input
          id="NFive"
          class="inputCode-ES"
          formControlName="NFive"
          [maxLength]="1"
          pattern="[0-9]*"
          (input)="onKeyUp($event, 'NSix')" />
        <input
          id="NSix"
          class="inputCode-ES"
          formControlName="NSix"
          [maxLength]="1"
          pattern="[0-9]*" />
      </div>
    </div>
    <small class="p-error flex justify-center -mt-1 mb-1" *ngIf="errorBadCodeSMS">
      {{ resource.signature.textBadCodeSms }}
    </small>
    <div class="flex mx-auto mb-6" *ngIf="displayErrorText">
      <small class="p-error mx-auto"
        ><b>{{ errorCodeSMS }}</b></small
      >
    </div>

    <div class="flex mx-auto">
      <p class="text-ES mx-auto">
        {{ resource.signature.notSms }}
        <a style="cursor: pointer" (click)="sendBackSmsCode()"
          ><span class="textB-ES">{{ resource.signature.notSmsB }}</span></a
        >
      </p>
    </div>
    <div class="flex my-8">
      <button
        pButton
        type="button"
        class="button-NS w-full"
        [disabled]="!numericCodeForm.valid"
        [label]="resource.nextstep.sign"
        (click)="validateStepTwo()"
        [loading]="isLoading"></button>
    </div>

    <div class="mb-5">
      <div class="flex my-2">
        <p class="textCodeError-ES">{{ resource.signature.textCodeError }}</p>
      </div>

      <div class="flex my-2" (click)="callClientService()">
        <p class="button-outline-call-ES">
          <span *ngIf="brand === 'VYV'; else textOtherBrand">
            {{ resource.signature.textCodeErrorB }} {{ sansEffetPhoneNumber }}
          </span>
          <ng-template #textOtherBrand>
            {{ resource.signature.textCodeErrorB }}
          </ng-template>
        </p>
      </div>
    </div>
  </div>
</div>
<div class="container mx-auto h-28 md:h-40">
  <app-footer class="footer"></app-footer>
</div>
<app-error-popup
  [show]="displayError"
  (cancel)="displayError = false"
  [title]="resource.error.oups"
  [text]="resource.error.api"></app-error-popup>

<p-dialog
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '350px', height: '270px', margin: '1rem' }"
  [closable]="true"
  [showHeader]="true"
  [baseZIndex]="10000">
  <p-header>
    <p>{{ titleModal }}</p>
  </p-header>
  <p class="text-P my-5">{{ descriptionModal }}</p>
  <div class="flex justify-center mt-10">
    <button
      pButton
      type="button"
      class="button-NS w-full"
      [label]="resource.lessorcertificate.confirmModal"
      (click)="confirmModal()"></button>
  </div>
</p-dialog>
<p-dialog
  [(visible)]="showCantSignModal"
  [header]="resource.signature.cantSignModalTitle"
  [modal]="true"
  [style]="{ width: '330px', margin: '1rem' }"
  [closable]="true"
  [baseZIndex]="10000">
  <p class="text-P my-5">{{ resource.signature.cantSignModalDesc_1 }}</p>
  <ul class="text-P my-5">
    <li>{{ resource.signature.cantSignModalDesc_3 }}</li>
  </ul>
  <div class="flex justify-center mt-5">
    <button
      pButton
      type="button"
      class="button-NS w-full"
      [label]="resource.signature.cantSignModalValidate"
      (click)="confirmModal()"
      [loading]="isLoading"></button>
  </div>
</p-dialog>
<p-dialog
  [(visible)]="displayContextErrorModal"
  [modal]="true"
  [style]="{ width: '380px', height: '250px', margin: '1rem' }"
  [closable]="true"
  [showHeader]="true"
  [baseZIndex]="10000"
  (onHide)="closeErrorModal()">
  <p-header>
    <p>{{ resource.errorquote.title }}</p>
  </p-header>
  <p class="text-P my-5">
    {{ resource.errorsign.message }}
  </p>
</p-dialog>
